<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <quotes />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import Quotes from '@/components/quotes/Quotes';

export default {
  name: 'SavedQuotes',
  components: { Quotes, BreadCrumb, Default },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Saved Quotes',
          disabled: true,
          to: { name: 'SavedQuotes' },
        },
      ],
    };
  },
  metaInfo: {
    title: 'Saved Quotes',
  },
};
</script>
